import React from "react";
import { Link } from "react-router-dom";
import TitlePanel from "../titles_page/title_panel/TitlePanel";

import "./SubtitlesPage.css"

var content = "$sum_(i=1)^n(s_n/lambda_n)$";

var definite_integral_calculation_formula = "$int_(a)^b f(x)dx$";
var improper_integral_formula = "$int_(0)^(+infty) f(x)dx$";
var integral_with_multiple_variables_formula = "$int f(x,t)dx$";
var double_integral_formula = "$int_(c)^d int_(a)^b f(x,y)dxdy$";
var integrals_memory_map = "Explore the Mind Map on integrals! 🧠"

const SubtitlesPageAdvancedIntegrals = () => {
    return (
        <div className="titles-page-div">
            <div className="choose-topic-div">
                <h2>Choose a topic</h2>
            </div>
            <div className="titles-container">
                <Link to="/advanced/integrals/memory_map" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Integrals Mind Map" formula={integrals_memory_map}/>
                </Link>

                <Link to="/advanced/integrals/definite_integral_calculation" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Definite Integral Calculation" formula={definite_integral_calculation_formula}/>
                </Link>

                <Link to="/advanced/integrals/double_integral" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Double Integral" formula={double_integral_formula}/>
                </Link>

                <Link to="/advanced/integrals/improper_integral" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Improper Integral" formula={improper_integral_formula}/>
                </Link>

                <Link to="/advanced/integrals/integral_with_multiple_variables" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Integral with Multiple Variable" formula={integral_with_multiple_variables_formula}/>
                </Link>

            </div>
        </div> 
    );
}

export default SubtitlesPageAdvancedIntegrals;